<template>
  <div class="common-outer-casing" @click="$emit('click')" :class="{ 'scroll-fix' : isScroll }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isScroll: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="stylus">
  html, body {
    overflow: hidden !important;
  }
  .main {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
<style lang="stylus">
  .scroll-fix {
    position: fixed;
    top: 0;
    left: 0;
  }
  .common-outer-casing {
    width: 100vw;
    height: 100vh;
    min-height: 550px;
    overflow: hidden;
    background-color: #fff;
  }
  .pc {
    .common-outer-casing {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
</style>
